// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"bdd63202","395":"5cba3153","943":"2396d60a","954":"08e5be18","980":"7155c1ba"}[chunkId] + ".chunk.css";
};